import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants, FILE_BLOB_TYPE, FILE_EXTENSION_TYPE } from 'src/app/app.constants';
import { NewsUpdateDetailsService } from "../../services/news-update-details.service";
import { filter, takeUntil, debounce, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { WindchillAccessResponse } from '../../shared/models/news-updates.model';
import { SnackBarService } from "../../services/snack-bar.service";
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { User, UserAudit } from 'src/app/shared/models/user.model';
import { Subject } from 'rxjs';
import { Links, sectionDetails } from 'src/app/shared/models/admin.model';
import { DownloadFileService } from "src/app/services/download-file.service";
import * as FileSaver from 'file-saver';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AdminRepositoryService } from 'src/app/services/admin-repository.service';

@Component({
  selector: 'app-news-updates-details',
  templateUrl: './news-updates-details.component.html',
  styleUrls: ['./news-updates-details.component.scss']
})
export class NewsUpdatesDetailsComponent implements OnInit {
  @Input() pageContents;
  searchTypeForm: UntypedFormGroup;
  panelOpenState = false;
  windchillFileInfo : any;
  hrefLinks = AppConstants;
  tooltipOptions: Object;
  expandPanel = true;
  searchResultFlag = false;
  windChillAccessData: WindchillAccessResponse;
  private cwsId: string;
  NOT_FOUND = 'Not Found.'
  FILE_ACCESS = 'Please contact Solar representative to access this file'
  isInternalUsers: boolean;
  EXTERNAL_ROLE_ID = [2,11,12,13];
  searchTypeOption = [
    { id: 'ESD', value: 'ES Spec' },
    { id: 'ITP', value: 'ITP' }
  ]

  private unsubscribe: Subject<void> = new Subject<void>();
  searchNoResultFlag: boolean;
  searchResultNotFound: boolean;
  isLoadingData: boolean;
  showErrormessage: boolean;
  showErrmessage: boolean;
  userAudit: UserAudit;

  
  constructor(private router: Router,
    private newsUpdateService: NewsUpdateDetailsService,
    private snackBarService: SnackBarService,
    private fb: UntypedFormBuilder,
    private userRepositoryService: UserRepositoryService,
    private downloadFileService: DownloadFileService,
    private adminRepositoryService: AdminRepositoryService) {
    this.tooltipOptions= {
      'placement': 'top',
      'show-delay': '1',
      'hide-delay': '1',
      'tooltip-class': 'sg-tooltip-upload',
      'tooltipClass' : 'sg-tooltip-upload',
      'pointerEvents' : 'none'
    };
  }

  ngOnInit() : void  {
    this.userRepositoryService.loggedUserData$.pipe(
      takeUntil(this.unsubscribe)).subscribe((user: User) => {
        this.cwsId = user.cwsId
        if(user) {
          this.isInternalUsers = !this.EXTERNAL_ROLE_ID.includes(user.roleId);
        }
       });
       this.loadSearchForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.pageContents && changes.pageContents.currentValue) {
      this.filterHomeContentInfo(changes.pageContents.currentValue);
    }
  }

  filterHomeContentInfo(response) {
    this.pageContents = response.sectionDetails.filter(data => data.staticContentName == 'HomeSectionsManagement');
    this.sortBasedOnOrderSequence();
  }

  sortBasedOnOrderSequence() {
    this.pageContents.sort((a,b) => {
      if(a.orderSequence < b.orderSequence) {
        return -1;
      } else if(a.orderSequence > b.orderSequence) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  onDocumentsClick() {
    this.router.navigate(['/documents'], { replaceUrl: true });
  }

  onComplianceRegulations() {
    this.router.navigate(['/complianceRegulations'], { replaceUrl: true });
  }

  downloadDocument(rowData){
    const extensionType = rowData.linkAddress.split(".")[1];
    const formTitle = rowData.linkTitle.split(".")[0];
    const downLoadInfo = {
      formName: formTitle,
      formNumber: '',
      extension: `.${extensionType}`
    };
      this.newsUpdateService.getDownloadStaticFile(rowData.linkAddress)
      .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (homeFileDownloadData: Blob) => {
          this.downloadFileService.downloadSolarForm(homeFileDownloadData, downLoadInfo, false);
        },
        (err) => {
          this.snackBarService.showError(err);
        }
      );
  }

  activateProjectLink() {
      this.newsUpdateService.getActiveProjectLink(this.cwsId).subscribe(
      (response) => {
        this.windChillAccessData = response;
       if(this.windChillAccessData.pjlAccess === 'true'){
        window.open(this.windChillAccessData.projectLink, "_blank");
       } else{
        this.snackBarService.showError(AppConstants.windChilProjectLinkAccessDenied);
       }
      });
  }

  loadSearchForm(){
    this.searchTypeForm = this.fb.group({
        searchTypeCtrl: this.fb.control(this.searchTypeOption[0].id),
        searchTextBoxCtrl: this.fb.control('')
    })
  }
  onChangeOption(id){
    this.searchTypeForm.controls.searchTextBoxCtrl.reset(null);
    this.searchResultFlag = false;
  }

  onSearchClick() {
    this.windchillFileInfo = '';
    let searchBoxValue = document.querySelector<HTMLInputElement>('input[name="user"]').value.toUpperCase();
   if(searchBoxValue == '') {
      this.showErrormessage = true;
      this.showErrmessage = false;
   } else {
    this.isLoadingData = true;
    this.showErrormessage = false;
    this.showErrmessage = false;
    let searchType = this.searchTypeCtrl.value;
    //let searchType = searchBoxValue.match(/ES/gi) ? 'ESD' : 'ITP';
    if(searchType == 'ITP') {
      if(searchBoxValue.lastIndexOf('-ITP') == -1) {
        searchBoxValue = searchBoxValue+'-'+searchType;
      }
    }
     if (searchType) {
       this.userRepositoryService.searchWindchillRecord(searchBoxValue, searchType)
         .pipe(takeUntil(this.unsubscribe))
         .subscribe((response: any) => {
           if (response) {
             const contentType = this.getContentType(response);
             if (contentType == 'string') {
               const reader = new FileReader();
               reader.onload = () => {
                 this.windchillFileInfo = reader.result as string;
               }
               reader.readAsText(response);
               this.isLoadingData = false;
               this.searchResultFlag = true;
               this.searchResultNotFound = true;
             } else {
              if(searchType == 'ITP') {
                FileSaver.saveAs(response, searchBoxValue + FILE_EXTENSION_TYPE.PDF);
                this.isLoadingData = false;
              } else {
                FileSaver.saveAs(response, searchBoxValue + FILE_EXTENSION_TYPE.PDF);
                this.isLoadingData = false;
              }
             }
           }
         },
           (error) => {
             this.searchNoResultFlag = true;
             this.showErrmessage = false;
             this.isLoadingData = false;
           });
     } 
      //   else {
      //   this.isLoadingData = false;
      //   this.showErrmessage = true;
      // }
    // if(searchType){
    // this.userRepositoryService.searchWindchillRecord(searchBoxValue, searchType)
    //   .pipe(takeUntil(this.unsubscribe))
    //   .subscribe((response: any) => {
    //     if (response) {
    //       if(response.fileName !== this.NOT_FOUND) {
    //         const blob = new Blob([response.fileContentResult.fileContents], {type: 'application/octet-stream'});
    //        // FileSaver.saveAs([response.fileContentResult.fileContents], 'ES_ITPFileData');
    //        const extensionType = response.fileContentResult.fileDownloadName.split(".")[1];
    //        const downLoadInfo = {
    //         formName: response.fileContentResult.fileDownloadName.split(".")[0],
    //         formNumber: '',
    //         extension: `.${extensionType}`
    //       };
    //         this.downloadFileService.downloadSolarForm(blob, downLoadInfo, false);
    //         this.isLoadingData = false;
    //       } else {
    //       this.windchillFileInfo = response;
    //       this.isLoadingData = false;
    //      // this.searchResultFlag = true;
    //     //  this.showErrmessage = false;
    //       if (response.fileName == this.NOT_FOUND || this.windchillFileInfo.message == this.FILE_ACCESS) {
    //         this.searchResultFlag = true;
    //         this.searchResultNotFound = true;
    //       } 
    //       // else {
    //       //   this.searchResultFlag = true;
    //       //   this.searchResultNotFound = false;
    //       // }
    //     }
    //     }
    //   },
    //     (error) => {
    //       this.searchNoResultFlag = true;
    //       this.showErrmessage = false;
    //       this.isLoadingData = false;
    //     });
    //   } else {
    //   this.isLoadingData = false;
    //   this.showErrmessage = true;
    // }

//=====================================================

    // if(searchType){
    //   this.userRepositoryService.getWindchillSearch(searchBoxValue, searchType)
    //     .pipe(takeUntil(this.unsubscribe))
    //     .subscribe((response) => {
    //       if (response) {
    //         this.windchillFileInfo = response;
    //         this.isLoadingData = false;
    //         this.searchResultFlag = true;
    //         this.showErrmessage = false;
    //         if (this.windchillFileInfo.message == this.NOT_FOUND || this.windchillFileInfo.message == this.FILE_ACCESS) {
    //           this.searchResultNotFound = true;
    //         } else {
    //           this.searchResultNotFound = false;
    //         }
    //       }
    //     },
    //       (error) => {
    //         this.searchNoResultFlag = true;
    //         this.showErrmessage = false;
    //         this.isLoadingData = false;
    //       });
    //     } else {
    //     this.isLoadingData = false;
    //     this.showErrmessage = true;
    //   }
   }
  }

  getContentType(res): 'blob' | 'string' {
    const blobtype = res.type;
    if (blobtype == 'text/plain') {
      return 'string';
    } else {
      return 'blob';
    }
  }

  onDownloadClick() {
    const extensionType = this.windchillFileInfo.url.split(".")[1];
    const downLoadInfo = {
      formName: this.windchillFileInfo.message,
      formNumber: '',
      extension: `.${extensionType}`
    };
    this.userRepositoryService.getWindchillFileDownload(this.windchillFileInfo.url)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe((response: Blob) => {
      // const data: Blob = new Blob([response], {
      //   type: FILE_BLOB_TYPE.PDF
      // });
      // FileSaver.saveAs(data, 'ES/ITP File Data' + FILE_EXTENSION_TYPE.PDF);
      this.downloadFileService.downloadSolarForm(response, downLoadInfo, false);
    },
    (err) => {
      this.snackBarService.showError(err);
    });
  }


  getLogData(documentName: string, documentCategory: string, action: string, linkType: string) {
    const logHeader = {
      documentName: documentName.split(".")[0],
      documentCategory: documentCategory,
      action: action,
      extension: "." + documentName.split('.').pop() || '', // "." + documentName.split(".")[1]
      formName: documentName.split(".")[0]
    };

    if (linkType === 'Document') {
      this.adminRepositoryService
        .getHomeSectionFile(documentName)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (solarFormDownloadData: any) => {
            this.downloadFileService.previewSolarForm(solarFormDownloadData, logHeader);//previewSolarForm(solarFormDownloadData, logHeader);
          },
          (err) => {
            // this.snackBService.showError(err);
          }
        );
    }

    if (documentCategory === 'Code Of Conduct') {
      this.userRepositoryService.getLogData(logHeader)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((response) => {
        });
    }
  }

  get searchTypeCtrl() {
    return this.searchTypeForm.get('searchTypeCtrl') as UntypedFormControl;
  }

  get searchTextBoxCtrl() {
    return this.searchTypeForm.get('searchTextBoxCtrl') as UntypedFormControl;
  }
}
